import React from "react";

import { styled } from "@mui/material/styles";

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material"; // Import icons

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
    border: "solid 1px #fff",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function TablePeriod({
  isLoading,
  dataPeriod,
  handlePeriodsClick,
  selectedPeriods,
  isAllPeriodsSelected,
  handleSelectAllPeriods,
}) {
  return (
    <>
      <TableContainer
        component={Paper}
        style={{ width: "100%", height: 400, overflow: "auto" }}
      >
        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width: "10px", padding: "8px" }}>
                <div
                  onClick={handleSelectAllPeriods}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {isAllPeriodsSelected ? (
                    <CheckBox />
                  ) : (
                    <CheckBoxOutlineBlank />
                  )}
                </div>
              </StyledTableCell>
              <StyledTableCell align="center">Period</StyledTableCell>
              <StyledTableCell align="center">Total Record</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataPeriod.length > 0 ? (
              dataPeriod.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  style={{
                    whiteSpace: "nowrap",
                    backgroundColor: selectedPeriods.includes(
                      String(row.period)
                    )
                      ? "#e0e0e0"
                      : "inherit",
                    cursor: "pointer",
                  }}
                  onClick={() => handlePeriodsClick(row)}
                  hover
                >
                  <TableCell align="center" sx={{ padding: "8px" }}>
                    {selectedPeriods.includes(String(row.period)) ? (
                      <CheckBox color="primary" />
                    ) : (
                      <CheckBoxOutlineBlank />
                    )}
                  </TableCell>
                  <TableCell align="center">{row.period}</TableCell>
                  <TableCell align="center">{row.total_record}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  {isLoading ? "Loading..." : "No Data Available"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
